import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { formatLocDateMMDDYY } from '@mummssoftware/utils/formatters';
import { styles } from '../../../utils/styles';

var _ref = /*#__PURE__*/React.createElement(Text, null);

export const EffectivePDF = ({
  carePlan
}) => /*#__PURE__*/React.createElement(View, {
  style: styles.width10
}, carePlan && carePlan.effectiveDate && /*#__PURE__*/React.createElement(Text, {
  style: styles.CPFTableDetailsText
}, formatLocDateMMDDYY(carePlan.effectiveDate)) || _ref);